import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/extension-lab')({
    component: ExtensionLabLayout,
    head: () => ({
        meta: [{ title: 'Extension Lab | Phoebe Admin' }],
    }),
});

function ExtensionLabLayout() {
    return <Outlet />;
}
